
let config_lineChartEV = {
    colors: [],
    credits: {
        enabled: false
    },
    title: {
        text: '' // leave empty to hide title
    },
    chart: {
        type: 'scatter',
        height: 600,
        zoomType: 'x',
        ignoreHiddenSeries: true,
        spacing: [31,0,31,0],
        backgroundColor: '#E7E4E0',
        resetZoomButton : {
            position: {
                y: -32
            },
        },
    },
    legend: {
        enabled: false
    },
    xAxis: {
        reversed: false,
        categories: [],
        crosshair: {
            enabled: false,
        },
        labels: {
            enabled: false
        },
        plotLines: [{ // mark the weekend
            color: '#222222',
            width: 2,
            //value for STAGE : 205.5 for LIVE 134.5
            value: 134.5,
            // dashStyle: 'longdashdot',
            clip: false,
            label: {
                text: `
                <div class="text-span-container">
                    <div class="text-span-party text-span-party--title"><span class="text-span-title">ΑΠΟΤΕΛΕΣΜΑΤΑ ΕΚΛΟΓΩΝ 21/05/2023</span></div>
                    <div class="text-parties-container visible" id="party-container">
                        <div class="text-span-party" ><span class="text-span-nd"></span><span>ΝΕΑ ΔΗΜΟΚΡΑΤΙΑ: 40,79%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-syriza"></span><span>ΣΥΡΙΖΑ: 20,07%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-pasok"></span><span>ΠΑΣΟΚ - ΚΙΝΑΛ: 11,45%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-kke"></span><span>ΚΚΕ: 7,23%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-ellusi"></span><span>ΕΛΛΗΝΙΚΗ ΛΥΣΗ: 4,45%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-niki"></span><span>ΝΙΚΗ: 2,92%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-plefsi"></span><span>ΠΛΕΥΣΗ ΕΛΕΥΘΕΡΙΑΣ: 2,89%</span></div>
                        <div class="text-span-party" id="party"><span class="text-span-mera25"></span><span>ΜΕΡΑ25: 2,63%</span></div>
                    </div>
                </div>`,
                rotation: 0,
                x: -5,
                align: "right",
                useHTML: true,
            },
            // events: {
            //     mouseover: () => {
            //         document.getElementById("party-container").classList.add("visible");
            //     },
            //     mouseout: () => {
            //         document.getElementById("party-container").classList.remove("visible");
            //     }
            // },
        }],
    },

    yAxis: {
        max: 65,
        min: 0,
        title: {
            text: 'Percent'
        },
        labels: {
            format: "{value} %"
        },
    },
    tooltip: {
        split: true,
        distance: 50,
    },
    plotOptions: {
        spline: {
            tooltip: {
                pointFormat: '{point.series.name}, {point.y} %',
                split: true,
            },
        },
        scatter: {
            tooltip: {
                headerFormat: '{point.series.date}',
                pointFormat: '{point.series.name}, {point.y} %',
            },

        },
    },
    responsive: {
        rules: [{
            condition: {
                maxWidth: 768
            },
            chartOptions: {
                xAxis: {
                    plotLines:[{
                        color: '#222222',
                        width: 2,
                        //value for STAGE : 205.5 for LIVE 134.5
                        value: 134.5,
                        // dashStyle: 'longdashdot',
                        clip: false,
                        label: {
                            text: `
                            <div class="text-span-container--mobile">
                                <div class="text-span-party text-span-party--title"><span class="text-span-title">ΑΠΟΤΕΛΕΣΜΑΤΑ ΕΚΛΟΓΩΝ 21/05/2023</span></div>
                                <div class="text-parties-container visible" id="party-container">
                                    <div class="text-span-party" ><span class="text-span-nd"></span><span>ΝΕΑ ΔΗΜΟΚΡΑΤΙΑ: 40,79%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-syriza"></span><span>ΣΥΡΙΖΑ: 20,07%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-pasok"></span><span>ΠΑΣΟΚ - ΚΙΝΑΛ: 11,45%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-kke"></span><span>ΚΚΕ: 7,23%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-ellusi"></span><span>ΕΛΛΗΝΙΚΗ ΛΥΣΗ: 4,45%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-niki"></span><span>ΝΙΚΗ: 2,92%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-plefsi"></span><span>ΠΛΕΥΣΗ ΕΛΕΥΘΕΡΙΑΣ: 2,89%</span></div>
                                    <div class="text-span-party" id="party"><span class="text-span-mera25"></span><span>ΜΕΡΑ25: 2,63%</span></div>
                                </div>
            
                            </div>`,
                            rotation: 0,
                            x: -3,
                            align: "right",
                            useHTML: true,
                        },
                    }]
                }
            }
        }]
    },
    series: []
}

let config_lineChartInt = {
    colors: [],
    credits: {
        enabled: false
    },
    title: {
        text: '' // leave empty to hide title
    },
    chart: {
        type: 'scatter',
        height: 500,
        zoomType: 'x',
        ignoreHiddenSeries: true,
    },
    xAxis: {
        reversed: false,
        categories: [],
        crosshair: {
            enabled: true,
        }
    },

    yAxis: {
        max: 65,
        min: 0,
        title: {
            text: 'Percent'
        },
        labels: {
            format: "{value} %"
        },
    },
    tooltip: {
        split: true,
        distance: 50,
    },
    plotOptions: {
        spline: {
            tooltip: {
                pointFormat: '{point.series.name}, {point.y} %',
            },
        },
        scatter: {
            tooltip: {
                headerFormat: '{point.series.date}',
                pointFormat: '{point.series.name}, {point.y} %',
            },

        },
    },
    series: []
};

const diagramsConfigInit = (parties, type) => {
    parties.forEach((party, index) => {
        let partyName = "";
        let partyColor = "";
        if (type === 'intention') {
            if (party.id < 9) {
                partyName = party.label
                partyColor = party.color
            }
            if (party.id === 9) {
                partyName = "Λ-Α-Α";
                partyColor = "#d2d2d2";
            }
            config_lineChartInt.series.push(
                {
                    //Scatter
                    type: "scatter",
                    name: partyName,
                    data: [],
                    opacity: 0.3,
                    enableMouseTracking: false,
                    showInLegend: false,
                    color: partyColor,
                    marker: {
                        enabled: true,
                        symbol: "round",
                        radius: 3,
                        fillColor: partyColor,
                    },
                },
                {
                    // Regression line
                    type: "spline",
                    name: partyName,
                    data: [],
                    showInLegend: true,
                    lineColor: partyColor,
                    color: partyColor,
                    marker: {
                        enabled: false,
                        symbol: "round",
                        fillColor: partyColor,
                    }
                }
            );
        }
        if (type === 'evaluation') {
            if (party.id < 8) {
                partyName = party.label
                partyColor = party.color
            }
            // if (party.id === 7) {
            //     partyName = "AΛΛΟ";
            //     partyColor = "#999999";
            // }

            config_lineChartEV.series.push(
                {
                    //Scatter
                    type: "scatter",
                    name: partyName,
                    data: [],
                    opacity: 0.3,
                    enableMouseTracking: false,
                    showInLegend: false,
                    color: partyColor,
                    marker: {
                        enabled: true,
                        symbol: "round",
                        radius: 3,
                        fillColor: partyColor,
                    },
                },
                {
                    // Regression line
                    type: "spline",
                    name: partyName,
                    data: [],
                    showInLegend: true,
                    lineColor: partyColor,
                    color: partyColor,
                    marker: {
                        enabled: false,
                        symbol: "round",
                        fillColor: partyColor,
                    }
                }
            );
        }
    })
}

export  {diagramsConfigInit, config_lineChartEV, config_lineChartInt}